import { render } from "./DashboardRiskCountBadge.vue?vue&type=template&id=1b073b2e"
import script from "./DashboardRiskCountBadge.vue?vue&type=script&lang=js"
export * from "./DashboardRiskCountBadge.vue?vue&type=script&lang=js"
script.render = render

export default script